import HeroSection from '../components/Home/HeroSection';
import ActionSection from '../components/Home/ActionSection';
import DonationInfoSection from '../components/Home/DonationInfoSection';

export default function Home() {
    return (
        <>
            <HeroSection />
            <ActionSection />
            <DonationInfoSection />
        </>
    );
}
